import React, { useEffect, useState, useRef } from 'react'
import { Link } from "react-router-dom"
import "./SAConsultora.scss"
import ModalConsultora from '../../Modales/Admin/superAdmin/ModalConsultora'
import { CSSTransition } from 'react-transition-group';
import ListaEmpresas from './ListaEmpresas';
import ListaConsultoras from './ListaConsultoras';
import { Oval } from 'react-loader-spinner'
import IllustrationAccess from "../../../assets/img/access.png"

import { useAdmin } from '../../../context/AdminContext';

export const vistaConsultorasContext = React.createContext()

function VistaConsultorasAdmin(props) {

  const { 
    consultoras,
    errorConsultora, 
    loadingConsultoras,
    fetchConsultoras,
    fetchEmpresasSinConsultora, 
    fetchEmpresasById 
  } = useAdmin()

  const [objConsul, setObjConsul] = useState(null)

  const [modalConsultora, setModalConsultora] = useState(false)

  const [idConsultora, setIdConsultora] = useState(null)

  const [expandedRowEmpresa, setExpandedRowEmpresa] = useState(null)

  useEffect(()=> {
    fetchConsultoras(props.user)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const user = props.user

  const handleEmpresasSinConsultora = async (id) => {
    setExpandedRowEmpresa(expandedRowEmpresa === id ? null : id)
    fetchEmpresasSinConsultora(props.user)
    setIdConsultora(id)
  }

  const handleEmpresasById = async (id) => {
    setExpandedRowEmpresa(expandedRowEmpresa === id ? null : id)
    fetchEmpresasById(props.user, id)
    setIdConsultora(id)
  }

  const handleModalConsultora = () => {
    setModalConsultora(true)
  }

  const handleModalEditConsul = (id) => {
    const obj = consultoras.find((e) => e.id_consultora === id)
    setObjConsul(JSON.stringify(obj))
    setIdConsultora(id)
    setModalConsultora(true)
  }

  const empresaRef = useRef()

  return (
    <>
      <vistaConsultorasContext.Provider value={{ user, idConsultora, setIdConsultora, objConsul, setObjConsul }}>
        <ModalConsultora show={modalConsultora} onHide={()=>setModalConsultora(false)} />
        {loadingConsultoras ? (
          <div className='loading__ConsultoraAdmin d-flex flex-column align-items-center justify-content-center'>
            <Oval
              visible={true}
              height="80"
              width="80"
              color="#0d6efd"
              ariaLabel="oval-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <p className='fw-medium'>Loading...</p>
          </div>
        ) : (
          <>
            {errorConsultora ? (
              <div className='error__ConsultoraAdmin d-flex flex-column align-items-center justify-content-center rounded-3'>
                <img className='img__error mb-4' src={IllustrationAccess} alt="" />
                <h2 className='text-danger fw-semibold mb-2'>Oops!</h2>
                <p className='text-center'>{errorConsultora}</p>
                <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
              </div>
            ) : (
              <>
                {consultoras.length === 0 ? (
                  <div className='container__consultoras--empty d-flex flex-column align-items-center justify-content-center rounded-3'>
                    <img className='img__empty mb-4' src={IllustrationAccess} alt="" />
                    <h3 className='text-blue-500 fw-semibold mb-3 text-center'>No tiene consultoras asignadas.</h3>
                    <button onClick={handleModalConsultora} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'>+ Agregar consultora</button>
                  </div>
                ) : (
                  <div className='container__consultoras'>
                    <div className='container__consultoras__title d-flex flex-column flex-md-row align-items-start align-items-md-center mb-4'>
                      <h4 className='text-blue-500 m-0 mb-2 mb-md-0 me-md-3'>Consultoras</h4>
                      <div className='flex-md-grow-1 d-flex flex-row justify-content-between'>
                        <button onClick={handleModalConsultora} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium me-3 me-md-0'>+ Agregar consultora</button>
                        <Link className='ms-auto btn btn-sm btn-primary rounded-pill px-3 fw-medium' to={'/admin/consultoras/flowchart'}>Ver Flowchart</Link>
                      </div>
                    </div>
                    <div className='container__consultoras__main scroll--y scroll--x'>
                      <div className='table__customC'>
                        <div className='table__customC__header'>
                          {/* El total del largo de este row es 940px + 40 margin-left en los botones */}
                          <div className='table__customC__cell cellC__dropdown'></div>
                          <div className='table__customC__cell cellC__buttons fw-bold text-blue-500'></div>
                          <div className='table__customC__cell cellC__id fw-bold text-blue-500 text-center'>#</div>
                          <div className='table__customC__cell cellC__name fw-bold text-blue-500 '>Nombre</div>
                          <div className='table__customC__cell cellC__name fw-bold text-blue-500 '>Detalles</div>
                          <div className='table__customC__cell cellC__name fw-bold text-blue-500 '>Fecha de creación</div>
                          <div className='table__customC__cell cellC__name fw-bold text-blue-500 '>Última modificación</div>
                        </div>
                        <div className='table__customC__body'>
                          <React.Fragment>
                            <div className='table__customC__row bgblue'>
                              <div className='table__customC__cell cellC__dropdown'>
                                <button className='btn__ico btn p-0' onClick={()=>handleEmpresasSinConsultora(0)}>
                                  {expandedRowEmpresa === 0 ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
                                </button>
                              </div>
                              <div className='table__customC__cell cellC__buttons'></div>
                              <div className='table__customC__cell cellC__id fw-bold text-center text-blue-500'>0</div>
                              <div className='table__customC__cell cellC__name'>Sin consultoras asociadas</div>
                              <div className='table__customC__cell cellC__name'></div>
                              <div className='table__customC__cell cellC__name'></div>
                              <div className='table__customC__cell cellC__name'></div>
                            </div>
                            <CSSTransition
                              in={expandedRowEmpresa === 0}
                              timeout={100}
                              classNames="details"
                              unmountOnExit
                              nodeRef={empresaRef}
                            >
                              <div ref={empresaRef} className='d-flex flex-column pt-4 pb-4 p-md-4'>
                                <ListaEmpresas />
                              </div>
                            </CSSTransition>
                          </React.Fragment>
                          {consultoras.map((e, i) => {
                            return <React.Fragment key={i}>
                              <div className='table__customC__row bgblue'>
                                <div className='table__customC__cell cellC__dropdown'>
                                  <button className='btn__ico btn p-0' onClick={()=>handleEmpresasById(e.id_consultora)}>
                                    {expandedRowEmpresa === e.id_consultora ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
                                  </button>
                                </div>
                                <div className='table__customC__cell cellC__buttons'>
                                  <button onClick={()=>handleModalEditConsul(e.id_consultora)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                </div>
                                <div className='table__customC__cell cellC__id fw-bold text-center text-blue-500'>{e.id_consultora}</div>
                                <div className='table__customC__cell cellC__name'>{e.nombre}</div>
                                <div className='table__customC__cell cellC__name'></div>
                                <div className='table__customC__cell cellC__name'></div>
                                <div className='table__customC__cell cellC__name'></div>
                              </div>
                              <CSSTransition
                                in={expandedRowEmpresa === e.id_consultora}
                                timeout={100}
                                classNames="details"
                                unmountOnExit
                                nodeRef={empresaRef}
                              >
                                <div ref={empresaRef} className='d-flex flex-column gap-4 pt-4 pb-4 p-md-4'>
                                  <ListaConsultoras />
                                  <ListaEmpresas />
                                </div>
                              </CSSTransition>
                            </React.Fragment>
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </vistaConsultorasContext.Provider>
    </>
  )
}

export default VistaConsultorasAdmin